/**
 * This will replace the element with a template
 * @example ng-replace="/views/footer.html"
 */

const ngReplace = [ function () {
    return {
        replace: true,
        /**
         * @param $item
         * @param $params {{ ngReplace }}
         */
        templateUrl: function( $item, $params ) {
            return $params.ngReplace;
        }
    }
}];

export default ngReplace;

